import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {LoginService} from '../login/login.service';
import {ChangePassword, ConfirmPasswordValidator} from '../login/login';
import {WaitingDialogComponent} from '../../shared/waiting-dialog/waiting-dialog.component';
import {MDBModalRef, MDBModalService, ModalContainerComponent} from 'angular-bootstrap-md';
import {Subject} from 'rxjs';
import {SuccessDialogComponent} from '../../shared/success-dialog/success-dialog.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  strongRegex: any = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
  action = new Subject();
 password :any[] = [];
  validatingForm: FormGroup;
  emptyPassword : boolean = false;
  wrongPassword: boolean = false;
  @ViewChild('popUpRef', { static: true }) popUpRef: ModalContainerComponent;


  constructor(private loginService: LoginService, private modalService : MDBModalService, private  formBuilder: FormBuilder) { }

  loggedInUser; any;
  checkForm() {
    console.log('form', this.validatingForm)
  }

  close() {
    this.action.next('OK');
  }


  setConfirmPassword(){
    if(this.validatingForm.controls.confirmPassword.errors != null) {

    }

  }
  ngOnInit() {
    this.validatingForm = this.formBuilder.group({
      // password: new FormControl('', [Validators.required]),
      // confirmPassword: new FormControl('', [Validators.required])
      password: new FormControl('', [Validators.required, Validators.pattern(this.strongRegex)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.pattern(this.strongRegex)])
    });
    /*this.validatingForm = new FormGroup({
      loginFormModalConfirmPswd: new FormControl('', Validators.required),
      loginFormModalPswd: new FormControl('', Validators.required)
    });*/

    this.loggedInUser = JSON.parse(sessionStorage.getItem('user'));
  }

  get f() { return this.validatingForm.controls; }

  userData: any;
  passwordJson: ChangePassword = new ChangePassword();
  // passObject: passwordJson
  getUserById(userId) {
    this.loginService.getUserById(userId).then((data) => {
      this.userData = data;
    })
  }

  successDialogRef: MDBModalRef;
  changePassword() {
    if(this.loginFormModalPassword.value && this.loginFormModalConfirmPassword.value) {
      this.emptyPassword = false;
     if( this.loginFormModalPassword.value === this.loginFormModalConfirmPassword.value ){
       this.wrongPassword = false;
    this.password[0]=this.loggedInUser.UserName;
    this.password[1]=this.loginFormModalPassword.value
    this.password[2] = "0";
    this.loginService.changePassword(this.password).then((data) => {
      console.log('sucss', data)
      if(data == 1) {
      this.action.next('OK');
      let dataa = [];
      this.successDialogRef = this.modalService.show(SuccessDialogComponent, {
        data: {
          message: 'Password Changed Successfully',
          data: dataa
        }
      })
      this.successDialogRef.content.action.subscribe((result: any) => {
        if (result == 'OK') {
          setTimeout(x => {
            this.successDialogRef.hide();
          }, 300)
        }
      }); 
   }
   if(data == 0) {
    this.action.next('OK');
    let dataa = [];
    this.successDialogRef = this.modalService.show(SuccessDialogComponent, {
      data: {
        message: 'Password Changed Successfully',
        data: dataa
      }
    })
    this.successDialogRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
        setTimeout(x => {
          this.successDialogRef.hide();
        }, 300)
      }
    }); 
 }
   }, error => {
      console.log('error', error)
    })
  }else {
    this.wrongPassword = true;
    setTimeout(x => {
      this.wrongPassword = false;
    }, 3000)
  }
} else {
  this.emptyPassword = true;
  setTimeout(x => {
    this.emptyPassword = false;
  }, 3000)
}
  }

  get loginFormModalConfirmPassword() {
    return this.validatingForm.get('confirmPassword');
  }

  get loginFormModalPassword() {
    return this.validatingForm.get('password');
  }




}
